import { styled } from "@linaria/react"

import { inputBaseStyles, inputFocusStyles, inputHoverStyles } from "@/styles/inputMixins.ts"

export const INPUT_HEIGHT_PX = 40
export const INPUT_PADDING_PX = 16

export const Input = styled.input`
  flex-grow: 1;
  height: ${INPUT_HEIGHT_PX}px;
  padding: 0 ${INPUT_PADDING_PX}px;

  ${inputBaseStyles};

  &:focus-visible {
    ${inputFocusStyles};
  }

  &:hover:not(:disabled, :focus-visible) {
    ${inputHoverStyles};
  }

  &::placeholder {
    color: var(--secondary-text-color);
  }
`

export const FullWidthInput = styled(Input)`
  width: 100%;
`
